import { ISearchStore } from '../index'

export default function(state: ISearchStore): ISearchStore {
  return {
    ...state,
    isLoading: true,
    isReady: false,
  }
}
